/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/notificationSettingsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a NotificationSettings. */
export class NotificationSettings {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a NotificationSettings.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Notification Settings API to return all notification settings.
   * @summary Retrieves all notification settings for for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.NotificationSettingsGetNotificationSettingsResponse>
   */
  getNotificationSettings(options?: Models.NotificationSettingsGetNotificationSettingsOptionalParams): Promise<Models.NotificationSettingsGetNotificationSettingsResponse>;
  /**
   * @param callback The callback
   */
  getNotificationSettings(callback: coreHttp.ServiceCallback<Models.AllNotificationSettings>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getNotificationSettings(options: Models.NotificationSettingsGetNotificationSettingsOptionalParams, callback: coreHttp.ServiceCallback<Models.AllNotificationSettings>): void;
  getNotificationSettings(options?: Models.NotificationSettingsGetNotificationSettingsOptionalParams | coreHttp.ServiceCallback<Models.AllNotificationSettings>, callback?: coreHttp.ServiceCallback<Models.AllNotificationSettings>): Promise<Models.NotificationSettingsGetNotificationSettingsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getNotificationSettingsOperationSpec,
      callback) as Promise<Models.NotificationSettingsGetNotificationSettingsResponse>;
  }

  /**
   * Calls Notification Settings API to update a specific notification settings.
   * @summary Updates the given notification settings.
   * @param [options] The optional parameters
   * @returns Promise<Models.NotificationSettingsUpdateNotificationSettingsResponse>
   */
  updateNotificationSettings(options?: Models.NotificationSettingsUpdateNotificationSettingsOptionalParams): Promise<Models.NotificationSettingsUpdateNotificationSettingsResponse>;
  /**
   * @param callback The callback
   */
  updateNotificationSettings(callback: coreHttp.ServiceCallback<Models.NotificationSettingResponse[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateNotificationSettings(options: Models.NotificationSettingsUpdateNotificationSettingsOptionalParams, callback: coreHttp.ServiceCallback<Models.NotificationSettingResponse[]>): void;
  updateNotificationSettings(options?: Models.NotificationSettingsUpdateNotificationSettingsOptionalParams | coreHttp.ServiceCallback<Models.NotificationSettingResponse[]>, callback?: coreHttp.ServiceCallback<Models.NotificationSettingResponse[]>): Promise<Models.NotificationSettingsUpdateNotificationSettingsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateNotificationSettingsOperationSpec,
      callback) as Promise<Models.NotificationSettingsUpdateNotificationSettingsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getNotificationSettingsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/NotificationSettings",
  queryParameters: [
    Parameters.includeFamily1
  ],
  responses: {
    200: {
      bodyMapper: Mappers.AllNotificationSettings
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateNotificationSettingsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/NotificationSettings",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "Sequence",
        element: {
          type: {
            name: "Composite",
            className: "NotificationSettingPayload"
          }
        }
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NotificationSettingResponse"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
